import React, { useState } from "react";
import * as Yup from "yup";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { showToast } from "../../utils/toast";
import { InputField } from "../../components/form/InputField";
import { postRequest } from "../../hooks/services/services";
import CommonModal from "../modal/CommonModal";
 
function ForgotPassword({ loginType = "Athlete" , onNext}) {
  const [showOTPModal, setShowOTPModal] = useState(false);
  const [emailForVerification, setEmailForVerification] = useState("");

  const schema = Yup.object().shape({
    email: Yup.string()
       .matches(
         /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
         "Invalid email format"
       )
       .email("Invalid email format")
       .required("Email is required"),
  });


  const onSubmit = async (data) => {
    // setLoading(true);
    try {
      const payload = {
        email: data?.email,
        type: loginType, 
      };
      const response = await postRequest('api/v1/passwords/forgot_password', payload);
      if(response?.status === 200){
        let responseData = await response.json()
        showToast(responseData?.message, "success");
        setEmailForVerification(data?.email);
        onNext(data?.email);
        setShowOTPModal(true);
       
      }
    } catch (error) {
      showToast(error.message, "error");
    }
  };

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(schema),
  });

  return (
    <div>
      <section class="form_part space-cmn">
        <div class="container">
          <div class="row">
            <div class="col-md-12">
              <div class="signupTab">
                <div class="formArea border-radius-20 border-gray">
                  <form onSubmit={handleSubmit(onSubmit)}>
                    <div class="row g-4">
                      <div class="col-md-12">
                        <div class="form-group">
                          <label>
                            Your Email <span class="text-danger">*</span>
                          </label>
                          <InputField
                            type="email"
                            placeholder=""
                            name="email"
                            register={register}
                            error={errors?.email?.message}
                          />
                        </div>
                      </div>
                      <div class="col-md-12">
                        <button type="submit" class="black_btn">
                          Submit
                        </button>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <CommonModal
        modelOpen={showOTPModal}
        setModelOpen={setShowOTPModal}
        headerContent="Verify OTP"
        modalType={{ name: "OtpVerification", email: emailForVerification, type: loginType }}
      />
    </div>
  );
}

export default ForgotPassword;
